<template>
<div class="container-fluid">
  <div class="row marketing">
    <div class="col-3">
      <h4 class="form-head">
        New Warehouse
      </h4>
      <form @submit="saveParty()" name="cform1">
        <div class="form-group">
          <label>Code(s)</label>
          <input-tag :tags.sync="c.codes"></input-tag>

        </div>
        <div class="form-group">
          <label for="un">Name</label>
          <input type="text" class="form-control"
                 id="un"
                 v-model="c.name">

        </div>
        <div class="form-group">
          <label for="pwd">Address</label>
          <input type="text" class="form-control"
                 id="pwd"
                 v-model="c.location">

        </div>
        <div class="form-group">
          <label for="pin">PinCode</label>
          <input type="text" class="form-control"
                 id="pin"
                 v-model="c.pinCode">

        </div>
        <div class="form-group">
          <label for="enabled">Enabled</label>
          <input type="checkbox" class="form-control"
                 id="enabled"
                 v-model="c.enabled">

        </div>

        <button type="submit" class="btn btn-primary">
          <i class="fa fa-save"></i> Save
        </button>

      </form>
    </div>
    <div class="col-9">
      <h4 class="form-head">
        Existing Locations
      </h4>
      <table class="table table-sm">
        <thead class="thead-dark">
        <tr>
          <th>Code(s)</th>
          <th>Name</th>
          <th>Address</th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="u of parties" :key="u.id">
          <td><input-tag :tags.sync="u.codes" :read-only="true"></input-tag></td>
          <td>{{u.name}}</td>
          <td>{{u.address}} {{u.pinCode}}</td>
          <td>
            <button class="btn btn-sm btn-secondary" v-on:click="editConsignee(u)">
              <i class="fa fa-pencil"></i>
            </button>
            <button class="btn btn-sm btn-success" v-on:click="enableLocation(u)" v-if="u.enabled !== true" v-b-tooltip.hover title="Enable Warehouse">
              <i class="fas fa-check"></i>
            </button>
            <button class="btn btn-sm btn-danger" v-on:click="disableLocation(u)" v-if="u.enabled === true" v-b-tooltip.hover title="Disable Warehouse">
              <i class="fas fa-times"></i>
            </button>
          </td>

        </tr>
        </tbody>
      </table>

    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
let apiUrl = `/app/location?admin=true`
let apiDeleteUrl = `/app/location/delete?admin=true`

export default {
  name: 'LocationsPage',
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (!this.$store.state.loggedIn) {
        console.log('Not Logged-in')
        this.$router.push('login')
      }
      this.loadConsignee()
    }, _ => {
      console.error('isLoggedIn Failed, lets go to login')
      this.$router.push('login')
    })
  },
  data () {
    return {
      c: {
        code: '',
        name: '',
        address: '',
        pinCode: '',
        enabled: true
      },
      parties: []
    }
  },
  methods: {
    loadConsignee: function () {
      axios.get(apiUrl)
        .then(response => {
          this.parties = response.data
        }, error => {
          console.error('Error in Loading Party', error)
        })
    },
    disableLocation: function (e) {
      axios.post(`${apiDeleteUrl}&id=${e.id}&enabled=false`)
        .then(_ => {
          this.parties.filter(p => p.id === e.id).forEach(p => {
            p.enabled = false
          })
        })
    },
    enableLocation: function (e) {
      axios.post(`${apiDeleteUrl}&id=${e.id}&enabled=true`)
        .then(_ => {
          this.parties.filter(p => p.id === e.id).forEach(p => {
            p.enabled = true
          })
        })
    },
    editConsignee: function (e) {
      this.c = Object.assign({}, e)
    },
    saveParty: function () {
      axios.post(apiUrl, this.c)
        .then(response => {
          this.c = {
            gstin: '',
            name: '',
            state: '',
            address: '',
            pincode: '',
            appPartyType: 'CONSIGNEE'
          }
          this.loadConsignee()
        }, error => {
          console.error('Error in Loading Party', error)
        })
    }
  }
}
</script>

<style scoped>
.vue-input-tag-wrapper.read-only {
  border: 0 none;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/LocationsPage.vue